import React, { ReactNode } from "react";
import * as Styled from "./CardContainer.styles";

interface CardContainerProps {
  children?: ReactNode;
}

export const CardContainer = ({ children }: CardContainerProps) => {
    return <Styled.Container>{children}</Styled.Container>;
};
